<template>
    <b-card no-body>
        <b-card-header>
            <h5 class="mb-0 text-white"><b>FILTROS</b></h5>
        </b-card-header>
        <b-card-body class="pt-2">
            <b-row>

                <b-col
                    cols="12"
                    md="4"
                    class="mb-2"
                >
                    <label for="conditions"><strong>CONDICION(ES)</strong></label>
                    <v-select
                        id="conditions"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        multiple
                        v-model="formData.conditionsArray"
                        :options="options.conditions"
                        class="w-100"
                        @input="inputConditionsVal()"
                    />
                </b-col>

            </b-row>

        </b-card-body>
    </b-card>
</template>

<script>

    import { ref, onBeforeMount } from '@vue/composition-api';
    import vSelect from 'vue-select';
    import axios from '@axios';

    export default {
        components: {
            vSelect
        },
        setup(props, { emit }) {

            // REFS
            const options = ref({});

            const formData = ref({
                conditionsArray: []
            });

            // CALL FUNCTION TO POPULATE OPTIONS FOR THE FILTERS
            onBeforeMount( async () => {
                await getSelectFilters();
            });

            const getSelectFilters = async () => {
                const { data } = await axios.get('/provider-forms/filters');
                options.value = data.data;
            };

            const inputConditionsVal = () => {
                if (formData.value.conditionsArray)
                {
                    const array = formData.value.conditionsArray.map(item => item.value);
                    emit('update:conditionsFilter', array.join(','));

                    return array;
                }

                return null;
            };

            return {
                // DATA
                formData,
                options,

                // METHODS
                inputConditionsVal
            }
        }
    }

</script>

<style lang="scss" scoped>

    .card-header {
        background-color: var(--primary);
        padding: 1rem 1.5rem;
    }

</style>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
